<div id="wrap" [class.macClassWrap]="macClass">
  <router-outlet (activate)="onActivate($event)"></router-outlet>
  <a href="/contact-us{{lang}}" routerLink="/contact-us{{lang}}" aria-label="Contact us">
    <div class="contact-ous-float">
      <i class="fa fa-phone" aria-hidden="true"></i>
    </div>
  </a>
</div>
